document.addEventListener("DOMContentLoaded", function() {
  
  let questions = qsa('.question');
  if(questions.length) {
    let firstItem = questions[0].nextElementSibling;
    questions[0].classList.add('active');
    firstItem.style.height = firstItem.scrollHeight + 'px';
    questions.forEach(el => {
      el.onclick = (e) => {
        let answer = el.nextElementSibling;
        if(el.classList.contains('active')) {
          el.classList.remove('active');
          answer.style.height = '0px';
        } else {
          el.classList.add('active');
          answer.style.height = answer.scrollHeight + 'px';
        }
      };
    })
  }
 
  function qs (selector, searchIn) {
    return searchIn ? searchIn.querySelector(selector) : document.querySelector(selector)
  }
  function qsa (selector, searchIn) {
    return searchIn ? searchIn.querySelectorAll(selector) : document.querySelectorAll(selector)
  }
});

$(document).ready(function() {
  var lastScrollTop = 0;
  var $topBar = $('#shopify-section-header');

  $(window).scroll(function() {
      var currentScroll = $(this).scrollTop();

      if (currentScroll > lastScrollTop) {
          // Scrolling down
          $topBar.addClass('hide-up');
      } else {
          // Scrolling up
          $topBar.removeClass('hide-up');
      }
      lastScrollTop = currentScroll;
  });
});